import React from 'react';

export const MultipleChoiceAnswerField = ({
	options = [],
	selectedOptions = null,
	onAnswerChange
}) => {

	const isChecked = (options, id) => {
		if (!options) return false;
    const index = options.findIndex(x => x.id === id);
		return index >= 0;
  };
	
	return (
		<div>
		{	
			options.length > 0 && options.map((opt) => (
				<div className="form-check" key={opt.id}>
					<input className="form-check-input"
						type="checkbox"
						name="radopt"
						id={opt.id}
						value={opt.id}
						checked={isChecked(selectedOptions, opt.id)}
						onChange={(e) => onAnswerChange(e.target.value)} />
					<label className="form-check-label" htmlFor={opt.id} >{opt.name}</label>
				</div>
			))
		}
		</div>
	);
};

export default MultipleChoiceAnswerField;
